"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = quoteStringDetector;

var _domWalkers = _interopRequireDefault(require("./dom-walkers"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
 * There are semi-common cases where immediately before a blockquote, we
 * encounter a string like: "On Thu … so and so … wrote:". This should be part
 * of the blockquote but was usually left as a collection of nodes. To help
 * with false-positives, we only look for strings like that that immediately
 * preceeded the blockquoted section. By the time the function gets here, the
 * last blockquote has been removed and the text we want will be at the end of
 * the document.
 *
 * This is in its own file to make use of ES6 generators
 *
 * See email_19 as a test case for this.
 */
function quoteStringDetector(doc) {
  var quoteNodesToRemove = [];
  var seenInitialQuoteEnd = false;

  var _iterator = _createForOfIteratorHelper(_domWalkers["default"].walkBackwards(doc)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;

      if (node.nodeType === Node.DOCUMENT_NODE) {
        continue;
      }

      if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim().length > 0) {
        if (!seenInitialQuoteEnd) {
          if (/wrote:\s*$/gim.test(node.nodeValue)) {
            seenInitialQuoteEnd = true;
            quoteNodesToRemove.push(node);

            if (/On \S/gim.test(node.nodeValue)) {
              // The beginning of the quoted string may be in the same node
              return quoteNodesToRemove;
            }
          } else {
            // This means there's some text in between the end of the content
            // (adjacent to the blockquote) and the quote string. We shouldn't be
            // killing any text in this case.
            return quoteNodesToRemove;
          }
        } else {
          quoteNodesToRemove.push(node);

          if (/On \S/gim.test(node.nodeValue)) {
            // This means we've reached the beginning of the quoted string.
            return quoteNodesToRemove;
          }
        }
      } else {
        if (seenInitialQuoteEnd) {
          quoteNodesToRemove.push(node);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return quoteNodesToRemove;
}
//# sourceMappingURL=quote-string-detector.js.map